import i18n from "../../../common/lang";
export const Columns=[
    {LabelName:i18n.t('lang.upgrade.FutureTask'),key:0,ColumnsKey:'tName',row: 150,seek:'tName',placeholder:i18n.t('lang.upgrade.search1'), sort: 'custom'},
    {LabelName:i18n.t('lang.upgrade.TaskStatus'),key:1,ColumnsKey:'tDescription',seek:'tDescription',placeholder:i18n.t('lang.upgrade.search2'), sort: 'custom' },
    {LabelName:i18n.t('lang.upgrade.completion'),key:2,align:'center',ColumnsKey:'progress',seek:'progress',placeholder:i18n.t('lang.upgrade.search3'),slot:true, sort: 'custom'},
    {LabelName:i18n.t('lang.upgrade.createFile'),key:3,ColumnsKey:'createFile',seek:'createFile',placeholder:i18n.t('lang.upgrade.search4'),Fun:'GetSpName', sort: 'custom'},
    {LabelName:i18n.t('lang.upgrade.KeepConfiguration'),key:4,row: 100,ColumnsKey:'tConfig',placeholder:i18n.t('lang.upgrade.search5'),Fun:'GetConfig'},
    {LabelName:i18n.t('lang.upgrade.TaskType'),key:5,row: 100,ColumnsKey:'tPackageType',placeholder:i18n.t('lang.upgrade.search5'),Fun:'GetPackageType'},
    {LabelName:i18n.t('lang.upgrade.StartingTime'),key:6,row: 150,ColumnsKey:'tCreate',placeholder:i18n.t('lang.upgrade.search5')},
    {LabelName:i18n.t('lang.upgrade.UPDATE_TO'),key:7,row: 150,ColumnsKey:'tUpdate',placeholder:i18n.t('lang.upgrade.search5'), sort: 'custom'}
]

export const ColuumnsButton=[
    {key:0,type:'danger',icon:'el-icon-delete',Delete:true,Fun:'delLevelUp',Authority:129}
]

export const Expands=[
    {LabelName:i18n.t('lang.upgrade.SerialNumber'),key:0,align:'center',ExpandsKey:'Index',slot:true},
    {LabelName:i18n.t('lang.upgrade.equipment'),key:1,align:'center',ExpandsKey:'deviceSn',Fun:'GetChildSn'},
    {LabelName:i18n.t('lang.upgrade.completion'),key:2,align:'center',ExpandsKey:'stSign',Tag:true,Fun:'GetChildStatus'},
    {LabelName:i18n.t('lang.upgrade.StartingTime'),key:3,align:'center',ExpandsKey:'stCreate'},
    {LabelName:i18n.t('lang.upgrade.UPDATE_TO'),key:4,align:'center',ExpandsKey:'stUpdate'}
]

export const ExpandsButton=[
    {key:0,type:'danger',icon:'el-icon-delete',Delete:true,Fun:'delSonLevelUp',Authority:130}
]